import { ChangeDetectorRef, OnDestroy, OnInit, } from '@angular/core';
import { ControlValueAccessor, FormGroup, ValidationErrors, Validators, } from '@angular/forms';
import { CronType, CustomCron, } from '@components/ui-cron/cron.models';
import { TranslateService } from '@ngx-translate/core';
import { unsubscribe } from '@utils/object.utils';
import UiValidators from '@validators';
var DAYS = [
    { id: 'MON', text: 'monday' },
    { id: 'TUE', text: 'tuesday' },
    { id: 'WED', text: 'wednesday' },
    { id: 'THU', text: 'thursday' },
    { id: 'FRI', text: 'friday' },
    { id: 'SAT', text: 'saturday' },
    { id: 'SUN', text: 'sunday' },
];
// TODO: (VJ) Rewrite this piece of garbage; (AG) +2
var UiCronComponent = /** @class */ (function () {
    function UiCronComponent(_cd, _translateService) {
        var _this = this;
        this._cd = _cd;
        this._translateService = _translateService;
        this.minutes = ['1', '5', '10', '15', '30'].map(function (entry) {
            return ({
                id: entry,
                text: entry,
            });
        });
        this.days = DAYS.map(function (day) { return ({
            id: day.id,
            weekly: _this._translateService.instant("cron_weekly_" + day.text),
            monthly: _this._translateService.instant("cron_monthly_" + day.text),
        }); });
        this._onChange = function () { };
        this._onTouch = function () { };
        this._weekDayFormValidator = function () {
            var cronType = _this.model.type;
            if ([CronType.Weekly, CronType.Monthly].indexOf(cronType) === -1) {
                return null;
            }
            var weekOrMonth = cronType === CronType.Weekly ?
                _this.model.weekly :
                _this.model.monthly;
            if (weekOrMonth.weekdays.length !== 0) {
                return null;
            }
            return { weekDay: true };
        };
    }
    UiCronComponent.prototype.onMinuteValueChanged = function (item) {
        this.model.minutely.atMinute = !item.id ? null : parseInt(item.id, 10);
    };
    UiCronComponent.prototype.typeIs = function (typeStr) {
        return CronType[typeStr] === this.model.type;
    };
    UiCronComponent.prototype.updateCronType = function (type) {
        var newType = CronType[type];
        this.model.type = newType;
        // AG: aaargh!
        if (this.model.type === CronType.Minutely) {
            var minutes = this.form.get('minutelyAtMinute').value;
            this.model.minutely.atMinute = minutes[0] && minutes[0].id ? parseInt(minutes[0].id, 10) : null;
        }
        this._onChange(this.model);
        this._setCronConditionalValidation();
        this.form.updateValueAndValidity();
        this.form.markAsDirty();
    };
    UiCronComponent.prototype.onDayChange = function (event, tab, weekdays, day) {
        this.updateCronType(tab);
        if (event.checked) {
            weekdays.push(day);
        }
        else {
            var index = -1;
            for (var i = 0; i < weekdays.length; i++) {
                if (weekdays[i].id === day.id) {
                    index = i;
                    break;
                }
            }
            if (index > -1) {
                weekdays.splice(index, 1);
            }
        }
        this._onChange(this.model);
        this.form.updateValueAndValidity();
        this.form.markAsDirty();
    };
    UiCronComponent.prototype.isWeekdayChecked = function (list, day) {
        return list && list.filter(function (d) { return d.id === day.id; }).length > 0;
    };
    UiCronComponent.prototype.onClick = function () {
        this._onTouch();
    };
    UiCronComponent.prototype.ngOnInit = function () {
        var _this = this;
        var isFormPristine = this.form.pristine;
        this.form.setValidators(this._weekDayFormValidator);
        var atMinute = this.model.minutely.atMinute;
        if (atMinute) {
            this.selectedMinute = [
                this.minutes
                    .find(function (m) { return m.id === atMinute.toString(); }) ||
                    this.minutes[0],
            ];
        }
        else {
            this.selectedMinute = [this.minutes[0]];
        }
        this._cd.detectChanges();
        // TODO: refactor this. Something causes the main form to read as dirty (AB)
        if (isFormPristine) {
            this.form.markAsPristine();
        }
        this._valueChangesSub = this.form.valueChanges.subscribe(function (value) {
            var model = _this.model;
            model.hourly.frequencyInHours = value.hourlyEveryHours;
            model.hourly.atMinute = value.hourlyAtMinute;
            model.daily.atHour = value.dailyAtHour;
            model.daily.atMinute = value.dailyAtMinute;
            model.weekly.atHour = value.weeklyAtHour;
            model.weekly.atMinute = value.weeklyAtMinute;
            model.monthly.frequencyInMonths = value.monthlyFrequency;
            model.monthly.atHour = value.monthlyAtHour;
            model.monthly.atMinute = value.monthlyAtMinute;
            model.advancedCronExpression = value.advancedCron;
        });
    };
    UiCronComponent.prototype.ngOnDestroy = function () {
        unsubscribe(this._valueChangesSub);
    };
    UiCronComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    UiCronComponent.prototype.registerOnTouched = function (fn) {
        this._onTouch = fn;
    };
    UiCronComponent.prototype.writeValue = function (value) {
        if (value) {
            this.model = value;
        }
    };
    Object.defineProperty(UiCronComponent.prototype, "value", {
        get: function () {
            return this.model;
        },
        set: function (v) {
            if (v !== this.model) {
                this.model = v;
                this._onChange(v);
            }
        },
        enumerable: true,
        configurable: true
    });
    // TO-DO: Investigate if this is necessary
    // the form inputs are already decorated with these validation attributes
    UiCronComponent.prototype._setCronConditionalValidation = function () {
        this._updateCronValidator('minutelyAtMinute', CronType.Minutely, Validators.compose([
            UiValidators.required(),
        ]));
        this._updateCronValidator('hourlyEveryHours', CronType.Hourly, Validators.compose([
            UiValidators.required(),
            UiValidators.range(1, 23),
        ]));
        this._updateCronValidator('hourlyAtMinute', CronType.Hourly, Validators.compose([
            UiValidators.required(),
            UiValidators.range(0, 59),
        ]));
        this._updateCronValidator('dailyAtHour', CronType.Daily, Validators.compose([
            UiValidators.required(),
            UiValidators.range(0, 23),
        ]));
        this._updateCronValidator('dailyAtMinute', CronType.Daily, Validators.compose([
            UiValidators.required(),
            UiValidators.range(0, 59),
        ]));
        this._updateCronValidator('weeklyAtHour', CronType.Weekly, Validators.compose([
            UiValidators.required(),
            UiValidators.range(0, 23),
        ]));
        this._updateCronValidator('weeklyAtMinute', CronType.Weekly, Validators.compose([
            UiValidators.required(),
            UiValidators.range(0, 59),
        ]));
        this._updateCronValidator('monthlyAtHour', CronType.Monthly, Validators.compose([
            UiValidators.required(),
            UiValidators.range(0, 23),
        ]));
        this._updateCronValidator('monthlyAtMinute', CronType.Monthly, Validators.compose([
            UiValidators.required(),
            UiValidators.range(0, 59),
        ]));
        this._updateCronValidator('monthlyFrequency', CronType.Monthly, Validators.compose([
            UiValidators.required(),
            UiValidators.range(1, 12),
        ]));
        this._updateCronValidator('advancedCron', CronType.Advanced, Validators.required);
    };
    UiCronComponent.prototype._updateCronValidator = function (subGroupName, cronType, validator) {
        var subgroup = this.form.controls[subGroupName];
        subgroup.setValidators(this.model.type === cronType ? validator : null);
        subgroup.updateValueAndValidity();
    };
    return UiCronComponent;
}());
export { UiCronComponent };
